module.exports = __webpack_public_path__ + "img/offer-games.9f7eaa57.svg";